<template>
  <div class="wrapper landing-page">
    <promo-modal />
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image landing-section-background darken"
      >
      </parallax>
      <div class="content-center">
        <div class="col-md-12">
          <img :src="require('@/assets/images/Asset 14@150x.png')" class="img-fluid logo-img" />
        </div>
        <!-- <img :src="require('@/assets/images/JG-transparent-500x439.png')" class="logo-img" /> -->
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">JG Estates</h2>
            <h5 class="description">
              JG Estates aim to be your partner in letting your property with a host of services that will make being a landlord a breeze.
            </h5>
            <h5 class="description">
              We offer services including <span class="bold-text">tenant sourcing</span>, <span class="bold-text">fully-managed letting</span> and <span class="bold-text">eviction handling</span>.
            </h5>
          </div>
        </div>
        <div class="separator separator-primary"></div>
          <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <!-- First image on the left side -->
              <div
                class="image-container image-left"
                style="background-image: url('img/jgestates-home-1.jpg')"
              >
                <p class="blockquote blockquote-primary blockquote-margin">
                  "My ambition for JG Estates is to bring affordability back to Landlords and fight back against high letting management rates"
                  <br />
                  <br />
                  <small>- Jay Gorania</small>
                </p>
              </div>


              <!-- Second image on the left side of the article -->
              <!-- <div
                class="image-container image-left-bottom"
                style="background-image: url('img/jgestates-home-2.jpg')"
              ></div> -->
            </div>
            <div class="col-md-6">
              <!-- First image on the right side, above the article -->
              <div
                class="image-container image-right custom-margin"
                style="background-image: url('img/jgestates-home-3.jpg')"
              ></div>
              <template>
                <h3 style="margin-top: 20px;">
                  First class marketing
                </h3>
                <p>
                  We advertise on all major property portals in order to cut down the time taken to find suitable tenants and ensure maximum exposure.
                </p>
                <p>
                  Your property details will be emailed to tenants registered on our extensive database.
                </p>
              </template>
              <template>
                <h3>
                  Maximise rent
                </h3>
                <p>
                  Our extensive marketing on all major property portals and proactive management team will maximise rent potential and reduce potential void periods.
                </p>
                <p>
                  Due to a high volume of tenant interest, you will enjoy the luxury of handpicking the exact tenant you wish to live in your property.
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--     *********     FEATURES 8      *********      -->
    <div class="features-8 section-image" style="background-image: url('img/jgestates-home-4.jpg')">
        <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Services</h2>
            <h4 class="description">Benefit from the following services available through JG Estates. Each will help provide you with peace of mind knowing that all possible outcomes have been taken care of from the outset.</h4>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <card>
                        <img slot="image" src="img/jgestates-home-5.jpg" class="rounded" alt="">
                        <div class="info text-center">
                            <div class="icon">
                                <i class="now-ui-icons ui-1_email-85"></i>
                            </div>
                            <h4 class="info-title">Complete referencing</h4>
                            <p class="description">Includes Right to Rent, credit and financial suitability checks as well as references from previous landlords</p>
                        </div>
                    </card>
                </div>
                <div class="col-md-3">
                    <card>
                        <img slot="image" src="img/jgestates-home-6.jpg" class="rounded" alt="">
                        <div class="info text-center">
                            <div class="icon">
                                <i class="now-ui-icons ui-1_calendar-60"></i>
                            </div>
                            <h4 class="info-title">Exhaustive inventory reports</h4>
                            <p class="description">A detailed report to protect you in the event of claims, damages or when needed for final deductions to tenants bonds </p>
                        </div>
                    </card>
                </div>
                <div class="col-md-3">
                    <card>
                        <img slot="image" src="img/jgestates-home-7.jpg" class="rounded" alt="">
                        <div class="info text-center">
                            <div class="icon">
                                <i class="now-ui-icons ui-1_send"></i>
                            </div>
                            <h4 class="info-title">Client money protection insurance</h4>
                            <p class="description">We provide all our clients with client money protection insurance</p>
                        </div>
                    </card>
                </div>
                <div class="col-md-3">
                    <card>
                        <img slot="image" src="img/jgestates-home-8.jpg" class="rounded" alt="">
                        <div class="info text-center">
                            <div class="icon">
                                <i class="now-ui-icons ui-2_like"></i>
                            </div>
                            <h4 class="info-title">Rent guarantee and legal service</h4>
                            <p class="description">With our nil excess rent guarantee and legal service of up to £2,500 per calendar month, landlords will be always be protected</p>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
        <!--     *********    END FEATURES 8      *********      -->

    <services-detailed />
    <div
      class="testimonials-1 section-image"
      style="background-image: url('img/jgestates-home-15.jpg')"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-6 ml-auto mr-auto text-center">
            <h2 class="title">Reviews</h2>
            <h4 class="description text-white">
              As most of our clients are recommendations feel free to check out our Trust Pilot reviews as well as the selection below
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <card type="testimonial">
              <!-- <img slot="avatar" class="img img-raised" src="img/reviews-blank-profile-pic.png" /> -->
              <p class="card-description">
                Best agent in town
              </p>
              <p class="card-description">
                Whether I have a simple question or require in depth detail concerning my property, I have the peace of mind knowing Jay will answer my calls and will deal with any issues I may have.
              </p>
              <p class="card-description">
                His level of service is peerless and I cannot recommend him highly enough.
              </p>
              <template slot="raw-content">
                <div class="icon icon-primary">
                  <i class="fas fa-quote-right"></i>
                </div>
                <div class="card-footer">
                  <h4 class="card-title">Mr. Ramnish Sharma</h4>
                </div>
              </template>
            </card>
          </div>
          <div class="col-md-4">
            <card type="testimonial">
              <!-- <img slot="avatar" class="img img-raised" src="img/reviews-blank-profile-pic.png" /> -->
              <p class="card-description">
                Outstanding commitment from JG Estates in Leicester!
              </p>
              <p class="card-description">
                I used the JG Estate services to sell my flat in Leicester after using the 'traditional' estate agents in my area. I would recommend JG Estates to all my friends and family going forward for the flexibility the services brings, but especially if you're in the East Midlands as you'll be in the safe hands of Jay.
              </p>
              <template slot="raw-content">
                <div class="icon icon-primary">
                  <i class="fas fa-quote-right"></i>
                </div>
                <div class="card-footer">
                  <h4 class="card-title">Kish</h4>
                </div>
              </template>
            </card>
          </div>
          <div class="col-md-4">
            <card type="testimonial">
              <!-- <img slot="avatar" class="img img-raised" src="img/reviews-blank-profile-pic.png" /> -->
              <p class="card-description">
                Fantastic service from day one. Evicted a problem tenant and replaced with a tenant who has now been living at the property for 3 years with no problems.
              </p>
              <p class="description">Currently looks after three of my properties.</p>
              <template slot="raw-content">
                <div class="icon icon-primary">
                  <i class="fas fa-quote-right"></i>
                </div>
                <div class="card-footer">
                  <h4 class="card-title">Rahul</h4>
                </div>
              </template>
            </card>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <contact-form></contact-form>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">

            <TrustPilot></TrustPilot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput, Tabs, TabPane } from "@/components";
import ServicesDetailed from "../components/Customised/ServicesDetailed.vue";
import ContactForm from "../components/Customised/ContactForm.vue";
import TrustPilot from "../components/Customised/TrustPilot.vue";
import PromoModal from "../components/Customised/PromoModal.vue";

export default {
  name: "landing-page",
  bodyClass: "landing-page",
  components: {
    Card,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    ServicesDetailed,
    ContactForm,
    TrustPilot,
    PromoModal,
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        message: "",
      },
    };
  },
};
</script>
<style scoped>
.logo-img {
  max-width: 50vw;
}
.landing-section-background {
  background-image:url(../assets/images/jgestates_home.jpg);
  filter: brightness(50%);
}
.bold-text {
  font-weight: 500;
}
.custom-margin {
  margin-top: 95px;
}
</style>
